@if (!useNewLayout) {
    <div
        [class.effect-shine]="firstTimeViewing"
        class="flex flex-col items-center justify-start gap-[4px] p-[12px] w-full bg-tarotea rounded-xl">
        <div
            (click)="togglePanel()"
            class="w-full flex flex-row justify-between items-center cursor-pointer">
            <div class="flex flex-row gap-[5px] items-center">
                <div class="text-blurple font-semibold text-12-16 font-avenir leading-5">
                    FOCUS NOW
                </div>
                <div
                    class="rounded-[3px] bg-white py-[2px] px-[3px] text-bluegrey-2 font-semibold font-inter text-[9px]"
                    >BETA</div
                >
                <a
                    target="_blank"
                    href="https://support.focusmate.com/en/articles/9994509-focus-now"
                    class="flex flex-col items-center justify-center rounded-lg px-[3px] h-3.5 cursor-pointer">
                    <fa-icon
                        (click)="helpIconClicked($event)"
                        class="text-[#808080] text-12-16"
                        [icon]="faInfoCircle"></fa-icon
                ></a>
            </div>

            <div class="cursor-pointer">
                @if (openPanel) {
                    <fa-icon class="text-blurple text-[14px]" [icon]="faCircleChevronUp"></fa-icon>
                } @else {
                    <fa-icon
                        class="text-blurple text-[14px]"
                        [icon]="faCircleChevronDown"></fa-icon>
                }
            </div>
        </div>

        @if (!openPanel) {
            <div class="w-full text-left text-bluegrey-1 text-xs font-medium font-inter"
                >Try a new way to focus.</div
            >
        } @else {
            <div
                class="w-full p-[16px] flex flex-col gap-[16px] bg-blurple-5 border-solid border-[1px] border-blurple-2 rounded-lg font-inter text-bluegrey-1">
                <div class="flex flex-col gap-[8px]">
                    <div class="text-xs font-semibold">
                        @if (activeSessionState == 'none') {
                            Start session now?
                        } @else if (activeSessionState == 'searching') {
                            Searching for a partner...
                        } @else {
                            You have an ongoing session.
                        }
                    </div>
                    <div class="text-xs font-medium">
                        @if (activeSessionState == 'none') {
                            We'll match you with the first available partner. You can start your
                            session right away.
                        } @else if (activeSessionState == 'searching') {
                            Join your session to get matched.
                        } @else {
                            Happy focusing!
                        }
                    </div>
                </div>
                @if (activeSessionState === 'none') {
                    <button
                        #startSessionButton
                        [disabled]="bookingSession"
                        (click)="onClickStartSessionButton()"
                        class="w-full display flex flex-row justify-center items-center text-center bg-blurple rounded-sm p-[6px] text-sm text-white font-semibold font-avenir"
                        [class.bg-grey]="bookingSession">
                        @if (!bookingSession) {
                            {{ buttonText() }}
                        } @else {
                            Starting...
                            <div
                                class="spin ml-[10px] w-[15px] h-[15px] border-solid border-[2px] border-white border-t-[4px] border-t-grey rounded-full"></div>
                        }
                    </button>
                }
            </div>

            <a
                href="https://form.focusmate.com/feedback"
                target="_blank"
                class="text-xs font-medium text-bluegrey-1 pt-[5px] no-underline">
                Feedback
                <fa-icon [icon]="faExternalLink" class="text-bluegrey-1 text-[14px]"></fa-icon>
            </a>
        }
    </div>
} @else {
    <div
        class="p-[16px] flex flex-col gap-[16px] bg-oatmilk border-solid border-[1px] border-latte-2 rounded-lg font-inter text-bluegrey-1">
        <div class="flex flex-col gap-[8px]">
            <div class="text-xs font-semibold">Start session now?</div>
            <div class="text-xs font-medium"
                >We'll match you with the first available partner. You can start your session right
                away.</div
            >
            <a
                target="_blank"
                href="https://support.focusmate.com/en/articles/9994509-focus-now"
                class="flex flex-col items-center justify-center rounded-lg px-[3px] h-3.5 cursor-pointer">
                <fa-icon
                    (click)="helpIconClicked($event)"
                    class="text-[#808080] text-12-16"
                    [icon]="faInfoCircle"></fa-icon
            ></a>
        </div>

        <button
            #startSessionButton
            [disabled]="bookingSession"
            (click)="onClickStartSessionButton()"
            class="w-full display flex flex-row justify-center items-center text-center bg-blurple rounded-sm p-[6px] text-sm text-white font-semibold font-avenir"
            [class.bg-grey]="bookingSession">
            @if (!bookingSession) {
                {{ buttonText() }}
            } @else {
                Starting...
                <div
                    class="spin ml-[10px] w-[15px] h-[15px] border-solid border-[2px] border-white border-t-[4px] border-t-grey rounded-full"></div>
            }
        </button>
    </div>
}
